import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import styled from 'styled-components';
import _ from 'lodash';

import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import BookElement from 'app/api/bookElement';

import { Box, Text } from 'grommet';
import {
  Table as SuperResponsiveTable,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from 'react-super-responsive-table';

import ScrollIntoViewIfNeeded from 'react-scroll-into-view-if-needed';
const scrollIntoViewOptions = { behavior: 'instant', block: 'start' };

const ResponsiveTable = styled(SuperResponsiveTable)`
  border-collapse: collapse;
  border-style: hidden;
  td,
  th {
    border: 1px solid gray;
    padding: 5px;
  }
`;

function TableRow({ data }) {
  return (
    <Tr>
      {_.map(data, (entry, index) => (
        <Td key={index}><Box align="center">{entry}</Box></Td>
      ))}
    </Tr>
  );
}

function TableHeader({ data }) {
  return (
    <Thead>
      <Tr>
        {_.map(data, (__, header) => (
          <Th key={header}>{header}</Th>
        ))}
      </Tr>
    </Thead>
  );
}
class Table extends React.Component {
  render() {
    const { AppState, path, content } = this.props;
    return (
      <React.Fragment>
        {content.caption && (
          <ScrollIntoViewIfNeeded
            options={scrollIntoViewOptions}
            active={_.isEqual(path, AppState.selectedSectionItem)}
          >
            <Box>
              <Text
                aria-label={content.caption}
                title="caption"
                weight="bold"
                alignSelf="center"
                textAlign="center"
              >
                {BookElement.extractTitleFromPath(path)} — {content.caption}
              </Text>
            </Box>
          </ScrollIntoViewIfNeeded>
        )}
        <Box background="accent-3" elevation="small">
          <ResponsiveTable border={1} aria-label="table">
            <TableHeader data={content.records[0]} />
            <Tbody>
              {_.map(content.records, (record, index) => (
                <TableRow key={index} data={record} />
              ))}
            </Tbody>
          </ResponsiveTable>
        </Box>
      </React.Fragment>
    );
  }
}

Table.propTypes = {
  /**
   * content path
   */
  path: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  /**
   * records, caption, and prefix
   */
  content: PropTypes.shape({
    records: PropTypes.array,
    caption: PropTypes.string,
    prefix: PropTypes.string,
  }),
};
Table.defaultProps = {
  content: {},
};

const Component = inject('AppState')(observer(Table));
Component.displayName = 'Table';
export const TableComponent = Table;
export default Component;



// WEBPACK FOOTER //
// ./src/app/components/BookElements/Table.js